// import videojs from 'video.js';
// import Icons from 'uikit/dist/js/uikit-icons'; // eslint-disable-line
import TweenMax from 'gsap/TweenMax';
import { TimelineMax, CSSPlugin } from 'gsap/all';
import { CountUp } from 'countup.js';
// import './_video-player';

// Make Video.js available to child theme
// window.videojs = videojs;

// Make UIKit icons available to the window.
// window.UIkit.use(Icons);


// Make GSAP available to Child theme
window.TweenMax = TweenMax;
window.TimelineMax = TimelineMax;
window.CSSPlugin = CSSPlugin;


const loadHeroVideo = () => {
  const heroVideo = document.querySelector('#my-video');
	if(!heroVideo ){
		return ;
	}
  const heroVideoSrc = '';

  const containerWidth = heroVideo.parentElement.offsetWidth;

  let videoSuffix = '';

  if (containerWidth <= 640) {
    videoSuffix = 'xs';
  } else if (containerWidth > 640 && containerWidth <= 960) {
    videoSuffix = 'sm';
  } else if (containerWidth >= 960 && containerWidth <= 1280) {
    videoSuffix = 'md';
  } else if (containerWidth >= 1280) {
    videoSuffix = 'lg';
  }

  if (heroVideo) {
    heroVideo.setAttribute('src', heroVideo.getAttribute(`data-src-${videoSuffix}`));
    heroVideo.setAttribute('preload','preload');
    heroVideo.setAttribute('poster', document.querySelector('.xdf-header__background-image img').getAttribute('src'));
  }
};

window.onload = (event) => {
 loadHeroVideo();
}
